<template>
  <v-layout>
    <v-dialog v-model="dialogVisible" max-width="900px" @click:outside="closeDialog">
      <v-card>
        <v-card-title>
          <span class="headline">Historial de Estados Internos</span>
        </v-card-title>

        <v-card-text>
          <div v-if="loading" class="text-center py-4">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>

          <div v-else-if="history.length === 0" class="text-center py-4">
            <v-icon large color="grey">history</v-icon>
            <p class="grey--text mt-2">No hay historial de estados internos disponible</p>
          </div>

          <v-data-table
            v-else
            :headers="headers"
            :items="history"
            :loading="loading"
            loading-text="Cargando..."
            :options="{
              descending: true,
              itemsPerPage: 15,
            }"
            :footer-props="{
              itemsPerPageOptions: [5, 10, 15, -1],
            }"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td>{{ (item.creation_date) }}</td>
              
                <td>
                    <div class="status-badge font-weight-medium" >
                    {{ item.internal_state ? item.internal_state.name : '-' }}
                    </div>
                </td>
                <td>
                  <div>
                    <strong>{{ item.user_created ? item.user_created.business_name : '-' }}</strong>
                    <div v-if="item.user_created && item.user_created.email" class="text-caption grey--text">
                      {{ item.user_created.email }}
                    </div>
                  </div>
                </td>
                <td>
                  <span v-if="item.observaciones">{{ item.observaciones }}</span>
                  <span v-else class="grey--text">-</span>
                </td>
                <td class="text-center">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon small color="purple" v-on="on" @click="openPrintLabel(item)">
                        label
                      </v-icon>
                    </template>
                    <span>Imprimir Etiqueta</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeDialog">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ModalPrintLabel 
      :dialog="dialog_print_label" 
      :productionOrder="productionOrder"
      :initialObservaciones="selected_history_for_print ? selected_history_for_print.observaciones : null"
      @updateDialog="updateDialogPrintLabel"
      @print="onPrintLabel"
    />
  </v-layout>
</template>

<script>
import { productionOrderService } from "@/libs/ws/productionOrderService";
import { generalService } from "@/libs/ws/generalService";
import ModalPrintLabel from "./ModalPrintLabel.vue";
import { formatUtils } from "@/libs/utils/formatUtils";

export default {
  components: { ModalPrintLabel },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    productionOrder: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      dialogVisible: false,
      history: [],
      loading: false,
      headers: [
        { text: "Fecha y Hora", value: "creation_date", align: "left", sortable: false },
        { text: "Estado Interno", value: "internal_state.name", align: "left", sortable: false },
        { text: "Usuario", value: "user_created.business_name", align: "left", sortable: false },
        { text: "Observaciones", value: "observaciones", align: "left", sortable: false },
        { text: "Acción", value: "action", align: "center", sortable: false },
      ],
      dialog_print_label: false,
      selected_history_for_print: null,
    };
  },
  watch: {
    dialog(val) {
      this.dialogVisible = val;
      if (val && this.productionOrder) {
        this.loadHistory();
      }
    },
  },
  methods: {
    loadHistory() {
      if (!this.productionOrder || !this.productionOrder.id) {
        return;
      }

      this.loading = true;
      this.history = [];

      productionOrderService
        .getInternalStateHistory(this.productionOrder.id)
        .then((response) => {
          if (response.status) {
            this.history = response.result;
          } else {
            this.$toast.error(response.msg, "Error");
          }
        })
        .catch((e) => {
          console.log("Error loading internal state history", e);
          this.$toast.error("Error al cargar historial de estados internos", "Error");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatDate(dateString) {
      if (!dateString) return "-";
      return formatUtils.formatDateTimeFromString(dateString);
    },
    closeDialog() {
      this.dialogVisible = false;
      this.history = [];
      this.$emit("updateDialog", false);
    },
    openPrintLabel(historyItem) {
      this.selected_history_for_print = historyItem;
      this.dialog_print_label = true;
    },
    updateDialogPrintLabel(value) {
      this.dialog_print_label = value;
      if (!value) {
        this.selected_history_for_print = null;
      }
    },
    onPrintLabel(data) {
      this.$parent.loading = true;
      productionOrderService
        .printLabel(data)
        .then((response) => {
          let nombre = "etiqueta_orden_" + data.production_order_id;
          if (!generalService.downloadPdf(response, nombre + ".pdf", true)) {
            this.$toast.error("Error al generar la etiqueta", "Error");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$toast.error("Error al generar la etiqueta", "Error");
        })
        .finally(() => {
          this.$parent.loading = false;
        });
    },
  },
};
</script>

<style scoped>
</style>
